var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Modal"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-button', {
          on: {
            "click": function click($event) {
              _vm.basicUsageModalVisible = true;
            }
          }
        }, [_vm._v(" Show modal ")])];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Custom transition"
    }
  }, [_c('a-button', {
    on: {
      "click": function click($event) {
        _vm.customTransitionModalVisible = true;
      }
    }
  }, [_vm._v(" Show modal ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Hide close button"
    }
  }, [_c('a-button', {
    on: {
      "click": function click($event) {
        _vm.hideCloseButtonModalVisible = true;
      }
    }
  }, [_vm._v(" Show modal ")])], 1), _vm.basicUsageModalVisible ? _c('a-modal', {
    on: {
      "close": function close($event) {
        _vm.basicUsageModalVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")]) : _vm._e(), _vm.customTransitionModalVisible ? _c('a-modal', {
    attrs: {
      "transition": "scale"
    },
    on: {
      "close": function close($event) {
        _vm.customTransitionModalVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")]) : _vm._e(), _vm.hideCloseButtonModalVisible ? _c('a-modal', {
    attrs: {
      "hide-close-button": ""
    },
    on: {
      "close": function close($event) {
        _vm.hideCloseButtonModalVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.loremIpsum) + " ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }